<div class="p-3 rounded" style="background: #f7f8fa;border-radius: 20px;">
  <h1 style="font-size: 16px; color: black; font-family: 'Inter', sans-serif">
    Refine Search
  </h1>
  <div class="row">
    <div class="col-12 col-sm-4 col-md-4 col-lg-4">

      <label for="article" class="form-label">
        <i class="bi bi-search me-1"></i>Article
      </label>
      <div class="position-relative">
        <input id="article" type="text" [formControl]="article" class="form-control filter-input"
          placeholder="Enter article" style="padding-right: 2.5rem;" />
        <button *ngIf="article.value?.length" class="btn-close position-absolute" type="button"
          style="right: 0.75rem; top: 50%; transform: translateY(-50%); z-index: 5; font-size: 0.6rem;"
          (click)="clearValue('article')">
          ×
        </button>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-md-4 col-lg-4">
      <label for="origin" class="form-label">
        <i class="bi bi-geo-alt me-1"></i>Origin
      </label>
      <div class="position-relative">
        <input id="origin" type="text" [formControl]="origin" class="form-control filter-input"
          placeholder="Country or region" style="padding-right: 2.5rem;" />
        <button *ngIf="origin.value?.length" class="btn-close position-absolute" type="button"
          style="right: 0.75rem; top: 50%; transform: translateY(-50%); z-index: 5; font-size: 0.6rem;"
          (click)="clearValue('origin')">
          ×
        </button>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-md-4 col-lg-4">
      <label for="variety" class="form-label">
        <i class="bi bi-tag me-1"></i>Variety
      </label>
      <div class="position-relative">
        <input id="variety" type="text" [formControl]="variety" class="form-control filter-input"
          placeholder="Type/variety" style="padding-right: 2.5rem;" />
        <button *ngIf="variety.value?.length" class="btn-close position-absolute" type="button"
          style="right: 0.75rem; top: 50%; transform: translateY(-50%); z-index: 5; font-size: 0.6rem;"
          (click)="clearValue('variety')">
          ×
        </button>
      </div>
    </div>

  </div>
</div>